import React, { useCallback } from 'react';
import c from 'classnames';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import DreamupIcon from '@wix/da-ds/pkg/Icons/16x16/DreamUpStars';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { changePrompt } from '../../../../../redux/form/actions';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './PromptSuggestion.scss';
const PromptSuggestion = ({ suggestion, className })=>{
    const dispatchChangePrompt = useAction(changePrompt);
    const handleClick = useCallback(()=>{
        dispatchChangePrompt(suggestion.promptText);
    }, [
        suggestion,
        dispatchChangePrompt
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        type: "button",
        className: c(s['root'], className),
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(DreamupIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true,
        className: s['icon']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, suggestion.promptText));
};
PromptSuggestion.displayName = 'PromptSuggestion';
export default PromptSuggestion;

//# sourceMappingURL=PromptSuggestion.js.map